export default "__VITE_ASSET__Dcovaz5L__"